export const OFFERWALL_EXCLUDED_PATHS = [
  "/articles/ufabet-mobile-access-latest-links-and-direct-website-guide/",
]

export const OFFERWALL_HIDE_CLASS = "no-offerwall-ads"

export const CLEVER_CORE_INLINE_SCRIPT = `
/* <![CDATA[ */
    (function (document, window) {
        var a, c = document.createElement("script"), f = window.frameElement;

        c.id = "CleverCoreLoader92483";
        c.src = "https://scripts.cleverwebserver.com/5ecc33b2cb732de60ed480e141081590.js";

        c.async = !0;
        c.type = "text/javascript";
        c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
        c.setAttribute("data-callback", "put-your-callback-function-here");
        c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
        c.setAttribute("data-callback-url-view", "put-your-view-macro-here");
        

        try {
            a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
        } catch (e) {
            a = !1;
        }

        a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
        a.parentNode.insertBefore(c, a);
    })(document, window);
/* ]]> */
`

export function isOfferwallExcludedPath(pathname) {
  const normalized = pathname.endsWith("/") ? pathname : `${pathname}/`
  return OFFERWALL_EXCLUDED_PATHS.includes(normalized)
}

export function hideOnRunAds() {
  if (typeof document === "undefined") return

  document.body.classList.add(OFFERWALL_HIDE_CLASS)
  document.getElementById("clever-core")?.remove()
  document.getElementById("AdsCoreLoader102266")?.remove()
  document.getElementById("CleverCoreLoader92483")?.remove()
  document
    .querySelectorAll(".clever-core-ads-offerwall, .ads-core-ads-offerwall")
    .forEach((el) => {
      el.innerHTML = ""
    })
}

export function showOnRunAds() {
  if (typeof document === "undefined") return

  document.body.classList.remove(OFFERWALL_HIDE_CLASS)
}

export function loadOnRunAds() {
  if (typeof document === "undefined") return
  if (document.getElementById("AdsCoreLoader102266")) return

  showOnRunAds()

  const cleverCore = document.createElement("script")
  cleverCore.id = "clever-core"
  cleverCore.type = "text/javascript"
  cleverCore.setAttribute("data-cfasync", "false")
  cleverCore.innerHTML = CLEVER_CORE_INLINE_SCRIPT
  document.body.appendChild(cleverCore)

  if (!document.querySelector(".clever-core-ads-offerwall")) {
    const cleverDiv = document.createElement("div")
    cleverDiv.className = "clever-core-ads-offerwall"
    document.body.appendChild(cleverDiv)
  }

  const adsCore = document.createElement("script")
  adsCore.id = "AdsCoreLoader102266"
  adsCore.type = "text/javascript"
  adsCore.setAttribute("data-cfasync", "false")
  adsCore.src =
    "https://sads.adsboosters.xyz/a93b34a191c56c0a804d480ee131c172.js"
  document.body.appendChild(adsCore)

  if (!document.querySelector(".ads-core-ads-offerwall")) {
    const adsDiv = document.createElement("div")
    adsDiv.className = "ads-core-ads-offerwall"
    document.body.appendChild(adsDiv)
  }
}

export function syncOnRunAds(pathname) {
  if (isOfferwallExcludedPath(pathname)) {
    hideOnRunAds()
    return
  }

  if (!document.getElementById("AdsCoreLoader102266")) {
    loadOnRunAds()
    return
  }

  showOnRunAds()
}
